import { createSlice } from '@reduxjs/toolkit'
import axios from 'axios'


export const avanceAcademicoSlice = createSlice({
    name: 'avanceAcademico', //importante, ya que se realizara llamdo mas tarde por nombre
    initialState: {
        avanceAcademico: {}
    },
    reducers: {
        setAvanceAcademico: (state, action) => {  //crear set
            state.avanceAcademico = action.payload
        }
    }
})


export const {  setAvanceAcademico } = avanceAcademicoSlice.actions

export default avanceAcademicoSlice.reducer



export const getAvanceAcademico = (data) => async (dispatch) => {


    try {


        return await axios
            .post(
                'https://ws.ugm.cl/api/v1_ufe/ufe_avance_academico', data,
                {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': process.env.REACT_APP_TOKEN
                    }
                }
            )
            .then(response => {
                 //console.log('avanceAcademico', response.data)
                dispatch(setAvanceAcademico(response.data))

            })

    } catch (error) {

        //console.log('dispatch error', error)

    }


}